export default "__VITE_ASSET__117401d4__"